import styled, { css } from 'styled-components';

export const menuItemPadding = css<{ $paddingRight?: string }>`
  padding-left: 13px;
  padding-right: ${({ $paddingRight }) => $paddingRight || '11px'};
`;

// export const indicatorStyle = css`
//   position: relative;
//   :after {
//     position: absolute;
//     right: var(--indicator-right-position, -10px);
//     top: -5px;
//     height: 9px;
//     width: 9px;
//     border-radius: 50%;
//     content: '';
//     background: #b08bef;
//   }
// `;
// export const indicatorStyleNoOffset = css`
//   ${indicatorStyle}

//   :after {
//     top: 0;
//   }
// `;

// const disabledStyle = css`
//   --white: var(--gray4c); -- solve better way
//   pointer-events: none;
//   cursor: not-allowed;
// `;

export const ItemWrapper = styled.div<{
  // $isDisabled: boolean;
  $minWidth?: string;
}>`
  position: relative;
  display: flex;
  /* $ {({ $ isDisabled }) => ($ isDisabled ? disabledStyle : '')} */
  ${({ $minWidth }) => ($minWidth ? `min-width: ${$minWidth};` : '')}
`;
